import React, {useRef} from 'react';
import useOnClickOutside from "../Utils/use-onclick-outside";
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";

const Notifications = (props) => {
    const {t, i18n} = useTranslation();
    const ref = useRef();

    useOnClickOutside(ref, () => {
        if(!document.body.classList.contains('open-menu')){
            closeNotifMenu()
        }
    });

    const showList = (event) => {
        event.currentTarget.parentNode.classList.toggle("header-notification--open")
    }
    const closeNotifMenu = () =>{
        if (document.getElementsByClassName('header-notification--open').length > 0) {
            document.querySelector('.header-notification').classList.remove('header-notification--open');
        }
        if(document.body.classList.contains('open-menu')){
            document.body.classList.remove('open-menu');
        }
    }

    if (!props.loadingNotifs && props.notificationMessages.messages && props.notificationMessages.messages.length >= 1) {
        let unreadMessages = props.notificationMessages.count;
        return (<React.Fragment>
            <div className={`header-notification ${unreadMessages.length >= 1 ? 'ring' : ''}`} ref={ref}>
                <button onClick={showList} className={'header-notification__button'} title={`${unreadMessages.length} notifications`}>
                    <i className="far fa-bell the_bell"></i>
                    {
                        unreadMessages !== 0 &&
                        <span className={'header-notification__button__qty'}>{unreadMessages > 99 ? '99+' : unreadMessages}</span>
                    }
                    <span className="header-notification__button__text ml-2">Notifications</span>
                </button>
                <div className={`header-notification__dropdown`}>
                    <ul>
                        {props.notificationMessages.messages.map((item) => {
                            return <li key={item.id}>
                                <Link to={`/profile/messages/${item.id}`}
                                      onClick={closeNotifMenu} title={t('profile.messages.list.row.readthe')}>
                                    <div className={'header-notification__dropdown__title'}>
                                        {item['title_'+i18n.language]}
                                    </div>
                                    <div className={'header-notification__dropdown__action'}>
                                        {!item.read ?
                                            <React.Fragment>
                                                <div className="status status--red"
                                                     style={{textAlign: 'left', fontSize: 16, cursor: 'pointer'}}
                                                     title={t('profile.messages.list.row.notread')}
                                                >
                                                    <i className="fas fa-eye-slash"></i>
                                                </div>
                                            </React.Fragment> :
                                            <React.Fragment>
                                                <div className="status status--black"
                                                     style={{textAlign: 'left', fontSize: 16, cursor: 'pointer'}}
                                                     title={t('profile.messages.list.row.read')}
                                                >
                                                    <i className="fas fa-eye"></i>
                                                </div>
                                            </React.Fragment>
                                        }
                                    </div>
                                </Link>
                            </li>
                        })}

                        <li className={'last-one'}>
                            <Link to={'/profile/messages'} className={'link--fs-14 link--upper'} onClick={closeNotifMenu}>
                                <strong>{t('profile.messages.list.row.readallitems')}&nbsp;<i className="fas fa-angle-right"></i></strong>
                            </Link>
                        </li>


                    </ul>
                </div>
            </div>
        </React.Fragment>)
    } else {
        return <React.Fragment>
            <div className={`header-notification`} >
                <Link to={'/profile/messages'} onClick={showList} className={'header-notification__button'}>
                    <i className="far fa-bell the_bell"></i>
                </Link>
            </div>
        </React.Fragment>
    }


};


export default Notifications;

